"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addSubscriptions(_a) {
    var _b = _a.modules, modules = _b === void 0 ? {} : _b, _c = _a.subscriptions, subscriptions = _c === void 0 ? {} : _c, _d = _a.subscriber, subscriber = _d === void 0 ? function (store) { return function (handler) { return store.subscribe(handler); }; } : _d;
    var _subscriptions = {};
    var pushSubscriptions = function (store, subscriptions) {
        subscriptions.forEach(function (subscription) { return subscription(store); });
    };
    if (modules) {
        subscriptions = Object.entries(modules).reduce(function (prev, _a) {
            var key = _a[0], _module = _a[1];
            if (_module.hasOwnProperty('subscriptions')) {
                prev = Object.entries(_module.subscriptions).reduce(function (result, _a) {
                    var sub = _a[0], value = _a[1];
                    sub = _module.namespaced ? key + '/' + sub : sub;
                    result[sub] = value;
                    return result;
                }, prev);
            }
            return prev;
        }, subscriptions);
    }
    _subscriptions = Object.entries(subscriptions).reduce(function (prev, _a) {
        var key = _a[0], value = _a[1];
        if (!Array.isArray(value)) {
            value = [value];
        }
        if (!prev.hasOwnProperty(key)) {
            prev[key] = [];
        }
        prev[key] = prev[key].concat(value);
        return prev;
    }, _subscriptions);
    return function (store) {
        subscriber(store)(function (mutation) {
            if (_subscriptions.hasOwnProperty(mutation.type)) {
                pushSubscriptions(store, _subscriptions[mutation.type]);
            }
        });
    };
}
exports.default = addSubscriptions;
//# sourceMappingURL=index.js.map